function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33D5BA",
  d: "M.238 4.371v-.498c.142-.048.332-.12.594-.19.237-.072.498-.12.784-.167.285-.047.546-.095.807-.119.262-.023.5-.047.713-.047l.261.166-1.33 6.296h1.022v.523c-.12.095-.286.166-.452.261-.166.071-.356.143-.546.214-.19.071-.38.119-.57.143-.19.023-.38.047-.547.047-.38 0-.618-.071-.76-.214C.07 10.644 0 10.477 0 10.311c0-.19.024-.38.048-.57.023-.19.07-.38.118-.618l.998-4.538-.926-.214zM1.473 1.07c0-.332.119-.594.333-.784C2.019.095 2.305 0 2.66 0c.38 0 .665.095.879.285.214.19.333.452.333.784 0 .309-.12.57-.333.737-.214.19-.523.285-.88.285-.332 0-.617-.095-.854-.285-.214-.167-.333-.404-.333-.737z"
});
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 11,
    fill: "none",
    viewBox: "0 0 4 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b2d1c26ae83018378c99c2cb98623869.svg";
export { ForwardRef as ReactComponent };